<template>
  <div style="background-color: #e9ebee; min-height: 100vh;">
    <div v-if="$device.isDesktop">
      <navbar-mobile v-if="!isEmpty(auth)"></navbar-mobile>
      <navbar-public v-else></navbar-public>

      <div v-if="isEmpty(auth)" style="margin-top: 50px;"></div>
      <nuxt/>
      <snack-bar-errors></snack-bar-errors>
    </div>

    <redirect-to-app v-if="$device.isDesktop === false"></redirect-to-app>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NavbarPublic from "~/layouts/partials/NavbarPublic";
import NavbarMobile from "~/components/mobile/molecules/Navbar";
import SnackBarErrors from "~/components/molecules/SnackBarErrors";

export default {
  components: {
    NavbarPublic,
    NavbarMobile,
    SnackBarErrors
  },

  computed: {
    ...mapState({
      auth: state => state.auth
    })
  }
}
</script>
